import React from 'react';
import { useId } from '@reach/auto-id';
import { MarginProps } from '../../../theme/styledProps';
import { Wrapper } from '../Wrapper/Wrapper';
import { StyledTextarea, TextareaResize, FormVariant } from './Textarea.styles';
import { HelperText } from '../HelperText/HelperText';
import { Label } from '../Label/Label';
import { extractMarginProps } from '../utils/extractMarginProps';

export interface TextareaProps extends React.ComponentPropsWithRef<'textarea'>, MarginProps {
  label?: string;
  helperText?: string;
  formVariant?: FormVariant;
  resize?: TextareaResize;
}

export const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ label, formVariant, helperText, id, resize, ...rest }, ref) => {
    const textareaId = `textarea--${useId(id)}`;
    const descriptionId = `textarea--help-text--${useId()}`;

    return (
      <Wrapper {...extractMarginProps(rest)}>
        {label && (
          <Label htmlFor={textareaId} variant={formVariant} mb="4">
            {label}
          </Label>
        )}

        <StyledTextarea
          id={textareaId}
          formVariant={formVariant}
          resize={resize || 'none'}
          ref={ref}
          aria-describedby={helperText ? descriptionId : undefined}
          aria-invalid={formVariant === 'error'}
          aria-errormessage={formVariant === 'error' ? helperText : undefined}
          {...rest}
        />

        {helperText && (
          <HelperText descriptionId={descriptionId} variant={formVariant} mt="4">
            {helperText}
          </HelperText>
        )}
      </Wrapper>
    );
  },
);
